<template>
    <div class="home">
        <div id="total">
            <Top style="position: absolute; z-index: 999;"/>
            <div id="home_content">
                <div class="home_img">
                    <div class="focus">
                        <swiper v-if="bannerList.length>0" :options="swiperOptions" class="rslides f426x240 rslides1">
                            <swiper-slide id="rslides1_s0" class="" v-for="(item,index) in bannerList" :key="index">
                                <a href="/" target="_blank">
                                    <img :src="item.picture" alt="建筑之魅">
                                </a>
                            </swiper-slide>
                        </swiper>
                        <a href="" class="rslides_nav rslides1_nav prev">Previous</a>
                        <a href="" class="rslides_nav rslides1_nav next">Next</a>
                    </div>
                </div>
                <div class="home_img1 ">
                    <div class="home_img_container">
                        <img src="../assets/images/home_bar.jpg" border="0" usemap="#Map">
                        <svg class="overlay-svg" width="100%" height="100%">
                            <rect x="23" y="8" width="197" height="61"
                                @click="navigateTo('/about', { category_id:aboutList[0].id })" fill="rgba(0,0,0,0)" />
                            <rect x="297" y="11" width="176" height="59"
                                @click="navigateTo('/about', { category_id:aboutList[0].id })" fill="rgba(0,0,0,0)" />
                            <rect x="570" y="15" width="182" height="53"
                                @click="navigateTo('/about', { category_id:aboutList[0].id })" fill="rgba(0,0,0,0)" />
                            <rect x="820" y="13" width="149" height="57"
                                @click="navigateTo('/crafts', { category_id:craftsList[0].id })" fill="rgba(0,0,0,0)" />
                        </svg>
                    </div>
                </div>
                <div class="home_bottom_content" style="width: 100%">
                    <div class="home_news">
                        <div class="hone_news_header">
                            <span><router-link
                                    :to="{path:'/news',query:{category_id:newsList[0].id}}">更多</router-link></span>新闻/NEWS
                        </div>
                        <div class="home_news_list">
                            <router-link v-for="(item,index) in news.slice(0,4)" :key="index"
                                :to="{path:'/newsdetail',query:{id:item.id,category_id:item.category_id}}">
                                <span>[{{item.created_at}}]</span>
                                {{item.title}}
                            </router-link>
                        </div>
                    </div>
                    <div class="home_about">
                        <div class="hone_news_header">关于我们/ABOUT</div>
                        <div class="home_about_content">这就是您要的建筑 —— 理想人居生态建筑幕墙环境，精雕细琢，臻品典藏。
                            中磊企业集团有限公司长期以来专注于........</div>
                        <div class="home_about_more">
                            <router-link :to="{path:'/about',query:{category_id:aboutList[0].id}}"><img
                                    src="../assets/images/about_more.jpg"></router-link>
                        </div>
                    </div>
                    <div class="home_case">
                        <div class="hone_news_header"><span><router-link v-if="casesList.length" active-class="current"
                                    :to="{path:'/case',query:{category_id:casesList[0].id}}">更多</router-link></span>工程案例
                            / CASE</div>
                        <div class="home_case_content" v-if="cases.length>0">
                            <a href="Javascript:;" v-for="(item,index) in cases" :key="index">
                                <img :src="item.picture">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import Top from '@/components/top'
    export default {
        components: {
            Top
        },
        data() {
            return {
                bannerList: [],
                aboutList: [],
                news: [],
                cases: [],
                casesList: [],
                newsList: [],
                craftsList: [],
                swiperOptions: {
                    loop: true,
                    effect: 'fade', //渐变
                    fadeEffect: { //交叉渐变
                        crossFade: true,
                        duration: 1000
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false // 用户操作后仍然自动切换
                    },
                    speed: 1500, // 切换时间设置为1.5秒
                    navigation: {
                        nextEl: ".next",
                        prevEl: ".prev"
                    }
                }
            }
        },
        mounted() {
            this.getBanner();
            this.getAbout();
            this.getCrafts();
            this.getCase();
            this.getCaseCategory();
            this.getNews();
            this.getNewsCategory();
        },
        methods: {
            async getBanner() {
                const res = await this.$request.post('banner/getAll')
                if (res.data.code === 0) {
                    this.bannerList = res.data.data;
                }
            },
            async getAbout() {
                const res = await this.$request.post('aboutcategory/getAll')
                if (res.data.code === 0) {
                    this.aboutList = res.data.data
                }
            },
            async getNews() {
                const res = await this.$request.post('news/getAll')
                if (res.data.code === 0) {
                    this.news = res.data.data.data
                    this.news.forEach(item => {
                        item.created_at = item.created_at.split(' ')[0]
                    })
                }
            },
            async getCase() {
                const res = await this.$request.post('cases/getAll')
                if (res.data.code === 0) {
                    this.cases = res.data.data
                    this.cases = this.cases.filter(item => item.is_hot === 1)
                }
            },
            async getCaseCategory() {
                const res = await this.$request.post('casescategory/getAll')
                if (res.data.code === 0) {
                    this.casesList = res.data.data

                }
            },
            async getNewsCategory() {
                const res = await this.$request.post('newscategory/getAll')
                if (res.data.code === 0) {
                    this.newsList = res.data.data
                }
            },
            async getCrafts() {
                const res = await this.$request.post('crafts/getAll')
                if (res.data.code === 0) {
                    this.craftsList = res.data.data
                }
            },
            navigateTo(path, query) {
                this.$router.push({ path, query });
            }
        },
    }
</script>

<style lang="css" scoped>
    .home_img_container {
        position: relative;
    }

    .overlay-svg {
        position: absolute;
        /* 设置为绝对定位 */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        /* 设置z-index高于图片，使其显示在图片上方 */
    }
</style>